import React from 'react';
import DialogBase from './DialogBase';

interface DialogOrganisatieActivateProps {
  open: boolean;
  organisatieNaam: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DialogOrganisatieActivate: React.FC<DialogOrganisatieActivateProps> = ({
  open,
  organisatieNaam,
  onClose,
  onConfirm
}) => {

  return (
    <DialogBase
      open={open}
      title={`Activeren als: ${organisatieNaam}`}
      contentText={`
              Indien u wijzigt van organisatie worden plannen en afstemmingsdossiers weergegeven van die organisatie en plannen die met die organisatie worden gedeeld. 
              Weet u zeker dat u infraplannen.nl wilt activeren voor ${organisatieNaam}?`}
      confirmButtonText="Ja"
      onClose={onClose}
      onConfirm={onConfirm}
    >
    </DialogBase>
  );
};

export default DialogOrganisatieActivate;
